import { GoToTopButton } from './GoToTopButton'
import { withGoToTopButton } from './withGoToTopButton'

const ConnectedGoToTopButton = withGoToTopButton(GoToTopButton)
export { ConnectedGoToTopButton as GoToTopButton }
